(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pms-header-tablet-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
    const desktopHeader = window.matchMedia('(min-width: 1000px)');
    desktopHeader.addEventListener('change', (event) => {
      if (!event.matches || !document.body.classList.contains('reveal-mobile-nav')) return;
      const closeButton = document.querySelector('.mobile-navigation-drawer .mobile-nav-toggle');
      if (!closeButton) return;
      const logoLink = document.querySelector('#pageheader .logo__link');
      if (logoLink && window.theme) window.theme.trapOpener = logoLink;
      closeButton.click();
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pms-homepage-logo-controls"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest('[data-pms-logo-control]');
    if (!button) return;
    const banner = document.getElementById(button.getAttribute('aria-controls'));
    if (!banner) return;
    const paused = banner.classList.toggle('pms-logo-paused');
    button.setAttribute('aria-pressed', String(paused));
    const label = paused ? button.dataset.labelResume : button.dataset.labelPause;
    button.setAttribute('aria-label', label);
    button.setAttribute('title', label);
  });
  } catch(e) { console.error(e); }
})();

})();
